(function(){
	'use strict';

	angular
		.module('app')
		.controller('AccessPanelLoginController', AccessPanelLoginController);

	function AccessPanelLoginController(API, $state, $http) {
		let vm = this;
		vm.callback = '';
		//$state.go('access-panel-auth', {isAuth: false})

		vm.submitLogin = (Login) => {
			$http.get(`https://api.o2.ag/api_cms/adm/login/?login=${Login.email}&senha=${Login.senha}`)			
			.then(result => {
				console.log(result.data)
				angular.copy({}, Login)
				vm.ItsOkayForm.$submitted = false;
				vm.ItsOkayForm.$setPristine();
				$state.go('access-panel-auth', {isAuth: true});
			})
			.catch(error => {
				vm.ItsOkayForm.$submitted = false;
				vm.callback = "Login incorreto!";
				console.log(error, 'error');
			});
		}
	}

})();
